<script setup lang="ts">
const props = defineProps<{
  pkg: string
}>()
defineEmits(['tapShowLocationAlert', 'tapSignIn'])
const { isLogged } = useUserInfo()

const gameGuideLink = computed(() => ({ 'jp.co.ponos.battlecatsen': 'https://docs.google.com/document/d/1mJb5Zs8CbqV6eA1LyscgydnNRbjz4mD0kW0ulf-UwjY/edit', 'air.com.lunime.gachaclub': 'https://docs.google.com/document/d/1EcG7HmlVOpSx_YP8b_2y04jGoPDtWBliTsw-pUHHfPA/edit' })[props.pkg] || 'https://docs.google.com/document/u/0/d/1DGeuKKTgFKACw0mShE_aLWTc-2DDCPqDjEQGMncvqQc/')
// const reRender = ref<string>('')

// onMounted(() => {
//   reRender.value = '1'
// })
</script>

<template>
  <!-- <div class="absolute inset-is--1.5 top--1.5 size-full rd-2 p-1.5 box-content" style="background: rgba(18, 18, 18, .3); backdrop-filter: blur(20px);" /> -->
  <!-- <div :key="reRender" class="w-0.25 transition-all-300" :class="{ 'h-61 mb-0': !isLogged, 'logged-skip-cls': isLogged }" /> -->
  <div class="absolute min-h-9 flex flex-col items-center gap-5 p-1.5" bottom="0 md:5 xl:10">
    <!-- service tips -->
    <div v-if="gameGuideLink" class="relative flex-center cursor-pointer items-center rd-2">
      <NuxtLink :to="gameGuideLink" class="flex-center" target="_blank">
        <span class="relative z-2 text-3.5 c-#fff c-op-50">{{ gameGuideLink === 'https://docs.google.com/document/u/0/d/1DGeuKKTgFKACw0mShE_aLWTc-2DDCPqDjEQGMncvqQc/' ? 'Do Not Play as a Guest' : 'How to save your game process' }}</span>
        <svg
          width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
          class="relative z-2 ml-2"
        >
          <g clip-path="url(#clip0_92_1286)">
            <circle cx="6" cy="6" r="6" fill="white" fill-opacity="0.2" />
            <path
              d="M4.5 5C4.5 4.17157 5.17157 3.5 6 3.5C6.82843 3.5 7.5 4.17157 7.5 5C7.5 5.82843 6.82843 6.5 6 6.5V7"
              stroke="white" stroke-opacity="0.5" stroke-linecap="round" stroke-linejoin="round"
            />
            <path
              d="M6.625 8.625C6.625 8.97018 6.34518 9.25 6 9.25C5.65482 9.25 5.375 8.97018 5.375 8.625C5.375 8.27982 5.65482 8 6 8C6.34518 8 6.625 8.27982 6.625 8.625Z"
              fill="white" fill-opacity="0.5"
            />
          </g>
          <defs>
            <clipPath id="clip0_92_1286">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </NuxtLink>
      <div class="absolute inset-is--1.5 top--1.5 box-content size-full rd-2 bg-gray-1 bg-op-30 p-1.5 backdrop-blur-20px" />
    </div>

    <!-- login tips -->
    <div v-if="!isLogged" class="relative z-2 flex-center lt-lg:hidden">
      <span class="relative z-2 mx-1.5 text-3.5 c-#fff c-op-50">{{ $t('gameDetail.signInTips') }}</span>
      <button
        class="ld-button relative z-2 h-6 gap-0 rd-1 pie-0.5 pis-1.5 text-3.5 ld-button-green-outline"
        @click="$emit('tapSignIn')"
      >
        <span class="text-2.5 font-600 lh-3">{{ $t('gameDetail.loginBtn') }}</span>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 3L7 6L5 9" stroke="current" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <!-- filter-bg -->
      <div class="absolute inset-is--1.5 top--1.5 box-content size-full rd-2 bg-gray-1 bg-op-30 p-1.5 backdrop-blur-20px" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.logged-skip-cls {
  animation: skipCLSAnimation 250ms ease-in forwards;

  @keyframes skipCLSAnimation {
    0% {
      height: 61;
    }

    100% {
      height: 0;
      margin-bottom: -31.5;
    }
  }
}
</style>
